import { masterurl, masterUserUrl, fingerUrl } from 'common/ajax/config'
import axios from 'axios'

// 业务请求
export const post = (api, obj, config = {}) => {
  return axios.post(masterurl + api, obj, config)
}

export const get = (api, params, config = {}) => {
  return axios.get(masterurl + api, {params}, config)
}

export const apiPost = (api, obj, config = {}) => {
  return axios.post(fingerUrl + api, obj, config).then((res) => {
    return Promise.resolve(res)
  })
}

// 用户请求
export const userPost = (api, obj, config = {}) => {
  return axios.post(masterUserUrl + api, obj, config)
}

export const userGet = (api, params, config = {}) => {
  return axios.get(masterUserUrl + api, {params}, config)
}

export const getUserInfo = () => {
  return userGet('/user/authUser/info/get', {}).then((res) => {
    if (res.code !== 0) {
      alert(res.message)
      location.href = '/'
    }
    return res
  })
}



// WEBPACK FOOTER //
// ./src/common/ajax/methods.js